export default
{
  "showHide":{
    "DistrictNameTextFiled":false,
    "ChonaikaiNameTextFiled":false,
    "JichikaiNameTextFiled":false,
    "AddressTextFiled":true,
    "PersonalNameECTextFiled":false,
    "AddressECTextFiled":false,
    "NumberECTextFiled":false,
    "RelationshipECTextFiled":false,
    "RepresentativeNameTextFiled":true,
    "RepresentativeHiraTextFiled":false,
    "RepresentativeKanaTextFiled":false,
    "EntryNameTextFiled":false,
    "EntryHiraTextFiled":false,
    "EntryKanaTextFiled":false,
    "HomePhoneNumberTextFiled":true,
    "FaxNumberTextFiled":false,
    "EvacuationTypeSelectBox":false,
    "TransportationSelectBox":false,
    "OtherTransportationTextFiled":false,
    "CarsTextFiled":false,
    "CarModelTextFiled":false,
    "CarColorTextFiled":false,
    "CarNumberPlateTextFiled":false,
    "ParkingTextFiled":false,
    "PetSelectBox":false,
    "PetStateSelectBox":false,
    "HouseDamageSelectBox":false,
    "InfraDamageSelectBox":false,
    "OtherDamageTextFiled":false,
    "CitizenSelectBox":false,
    "Spare1RTextFiled":false,
    "Spare2RTextFiled":false,
    "Spare3RTextFiled":false,
    "Spare4RTextFiled":false,
    "Spare5RTextFiled":false,
    "PersonalNameTextFiled":true,
    "PersonalHiraTextFiled":false,
    "PersonalKanaTextFiled":false,
    "GenderSelectBox":true,
    "BirthDateYearSelectBox":true,
    "BirthDateMonthSelectBox":true,
    "BirthDateDaySelectBox":true,
    "AgeTextFiled":true,
    "TelephoneNumberTextFiled":false,
    "RelationshipTextFiled":false,
    "NationalitySelectBox":false,
    "OtherNationalityTextFiled":false,
    "LanguageTextFiled":false,
    "EvacuationFormSelectBox":false,
    "OtherEvacuationFormTextFiled":false,
    "PlaceSelectBox":false,
    "OtherPlaceTextFiled":false,
    "FoodsSelectBox":false,
    "OtherFoodsTextFiled":false,
    "DiseaseTextFiled":false,
    "InjuryTextFiled":false,
    "ShoniIryoSelectBox":false,
    "JinkoTosekiSelectBox":false,
    "SansoRyohoSelectBox":false,
    "FujinkaIryoSelectBox":false,
    "SeishinIryoSelectBox":false,
    "FeverCoughSelectBox":false,
    "KaigoTextFiled":false,
    "DeficiencySelectBox":false,
    "RiskSelectBox":false,
    "BloodTypeSelectBox":false,
    "MedicineSelectBox":false,
    "MedicineTextFiled":false,
    "AllergyTextFiled":false,
    "DisabledTextFiled":false,
    "IryokikiSelectBox":false,
    "PregnancySelectBox":false,
    "ChildSelectBox":false,
    "RequestTextFiled":false,
    "CooperationSelectBox":false,
    "OtherCooperationTextFiled":false,
    "FreeTextFiled":false,
    "InformationSelectBox":false,
    "DisclosureSelectBox":false,
    "Spare1TextFiled":false,
    "Spare2TextFiled":false,
    "Spare3TextFiled":false,
    "Spare4TextFiled":false,
    "Spare5TextFiled":false
  },
  "displayName": {
    "spare1R":"予備１",
    "spare2R":"予備２",
    "spare3R":"予備３",
    "spare4R":"予備４",
    "spare5R":"予備５",
    "spare1":"予備１",
    "spare2":"予備２",
    "spare3":"予備３",
    "spare4":"予備４",
    "spare5":"予備５"
  },
};
